import React from 'react';
import ModalWrapper, { withOnClose } from './ModalWrapper';
import Translator from '../../requests/apa/Translator';
import Asset from '../../requests/apa/Asset';
import PropTypes from 'prop-types';
import AnalyticsDimensionSingleton from '../../components/Header/AnalyticsDimensionSingleton';
import './styles/AAFModalError.scss';
import Utils from "../../utils/Utils";

const AAFModalError = (props = {}) => {
  const buttonLabelDefault = Translator.get('alert_warning_generic_button_close', 'ACEPTAR');
  const contentDefault = Translator.get('alert_warning_generic_message_label');
  const defaultTitle = Translator.get('ti_modal_retry', '¡Ocurrió algo inesperado!');
  const title = props.title || defaultTitle;
  const { code, message, textButton, colorButton, withBack = true, errorFrom, extendedMessage: {resultCode = '', resultMessage = ''} = {} } = props.content;
  let content = Translator.get(code, contentDefault);
  if (message && typeof message === 'string') content = Translator.get(message);
  const replaces = props.replaces || null;
  const alertIcon = Asset.get(`${code}_icon`) === `${code}_icon` ? Asset.get('alert_warning_generic_icon'): Asset.get(`${code}_icon`);

  let buttonLabel = Translator.get(`${code}_close`, buttonLabelDefault);
  let styleColorButton = undefined;

  const labelReplace = Translator.get('alert_warning_external_message_label', '');
  if (props.session && !code) {
    content = Translator.get(
      'error_404_not_found',
      'Servicio no disponible, intentar más tarde'
    );
  }
  const isHome = window.location.pathname.includes("detailtransaction")

  if (errorFrom === "parental-rating-mis_grabaciones") {
      buttonLabel = textButton;
      styleColorButton = colorButton;
  }

  /**
   * validate if display or not additional info
   * @returns label
   */
  const labelDetailMessage = () => {
    if (labelReplace !== '' && (resultCode !== undefined || resultCode !== null || resultCode !== '') && resultMessage) {
      return labelReplace.replace('@resultCode', resultCode).replace('@resultMessage', resultMessage);
    }
    return '';
  }

  if (typeof props.setMetricsEvent === 'function') {
    const sendDimension = () => {
      const payload = new AnalyticsDimensionSingleton().getPayload();
      props.setMetricsEvent(payload);
      props.setMetricsEvent({ type: 'executor' });
    };
    const sendMetric = () => {
      props.setMetricsEvent({
        hitType: 'event',
        eventCategory: 'errores',
        eventAction: title,
        eventLabel: content,
      });
      props.setMetricsEvent({ type: 'executor' });
      sendDimension();
    };
    sendMetric();
  }

  const p = {
    showLogo: labelDetailMessage() !== '',
    content,
    replaces,
    children: labelDetailMessage(),
    asset: props.asset ? Asset.get(props.asset) : alertIcon,
    alwaysEnabled: true,
    handleBackKey: props.handleBackKey ? props.handleBackKey : (e) => props.handleClose(e, props.callback),
    /**
     * Always enabled in modal error
     * @returns yellow button
     */
    yellowAction: (e) => props.handleClose(e, props.callback),
    colorButtons: labelDetailMessage() !== '' || !withBack ? [] : [
        {
            content: Translator.get('top_head_option_button_back', 'REGRESAR'),
            props: {
                color: 'yellow',
                className: 'modal-button-return',
                imgSrc: Asset.get('top_head_option_back', ''),
                onClick: (e) => {
                  props.handleClose(e, props.callback);
                },
            },
        },
    ],
    buttons: [
      {
        content: buttonLabel,
        props: {
          onClick: (e) => {
            props.handleClose(e, props.callback);
          },
          className: 'aaf-modal-button aaf-modal-button-primary',
          style: { backgroundColor: styleColorButton } 
        },
      },
    ],
    aafNewStyle: true,
    className: 'aaf-modal aaf-modal-error',
  };

  if (props.title) p.title = title;
  isHome && Utils.setInitialFocusChangeTime(".aaf-modal-button-primary", 500);
  return <ModalWrapper {...p} />;
};

AAFModalError.propTypes = {
  asset: PropTypes.string,
  title: PropTypes.string,
  content: PropTypes.object,
  callback: PropTypes.func,
  className: PropTypes.string,
};

AAFModalError.defaultProps = {
  content: {
    code: 'modal_msg_error_default',
    message: 'Por favor vuelve a intentarlo',
  },
  callback: () => {
    console.log('callback...');
  },
};

export default withOnClose(AAFModalError);



// WEBPACK FOOTER //
// ./src/components/Modal/AAFModalError.jsx